export default "__VITE_ASSET__ChS1M_lo__"